export default {
    van: true,
    motor: false,
    home: true,
    device: true,
    travel: true
}